import { useEffect } from "react";


function useOutsideClicked(ref,dropdownButtonRef, closeDropdown) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (event.target.closest('.modal')) return;
            if (ref.current && !ref.current.contains(event.target) && dropdownButtonRef.current && !dropdownButtonRef.current.contains(event.target)) {
                closeDropdown()
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}
export default useOutsideClicked;
